import * as _ from 'lodash';
import {
  Component,
  OnInit,
  OnDestroy,
  Self,
  Optional,
  ElementRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
  // Input,
  // OnChanges,
  ViewChild,
  // SimpleChanges,
} from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { DidEntity } from '@wephone-core/model/entity/did';
import { MatFormFieldControl } from '@angular/material/form-field';
import {
  IFlexSelectOptions,
  FlexMatInputWrapper,
  regexSearch,
  // ToastService
} from '@wephone-utils';
import { UserProfileService, CallingNumber } from '@wephone/services/user-profile.service';
import { MatSelectChange } from '@angular/material/select';
// import { CallQueueEntity } from '@wephone-core/model/entity/callqueue';
import { FlexSelect } from '@wephone-utils/form-input/flex-select/flex-select.component';
import { CallQueueRepository } from '@wephone-core/model/repository/callqueue';
import { _ti } from '@wephone-translation';
import { Observable } from 'rxjs';

@Component({
  selector: 'calling-number-form-input',
  templateUrl: './calling-number-select.component.html',
  styleUrls: ['./calling-number-select.component.scss'],
  providers: [{ provide: MatFormFieldControl, useExisting: CallingNumberSelectFormInput }],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallingNumberSelectFormInput extends FlexMatInputWrapper
  implements OnInit, OnDestroy, MatFormFieldControl<DidEntity> {
  static nextId = 0;
  // @Input() queueId: number;
  @Output() readonly selectionChange = new EventEmitter<MatSelectChange>();
  @ViewChild('flexSelector', { static: true }) flexSelector: FlexSelect;

  // private hasInitilized = false;
  // private queue: CallQueueEntity;
  flexSelect: FormControl = new FormControl();
  flexSelectOptions: IFlexSelectOptions;

  private readonly callqueueRepo = CallQueueRepository.getInstance<CallQueueRepository>();
  constructor(
    @Optional()
    @Self()
    ngControl: NgControl,
    elRef: ElementRef,
    readonly cdRef: ChangeDetectorRef,
    private readonly profileService: UserProfileService,
    // private readonly toastService: ToastService,
  ) {
    super(ngControl, elRef);
    this.flexSelectOptions = {
      compareWith: (a: CallingNumber, b: CallingNumber) => (a && b ? a.id === b.id : a === b),
      filterFunc: (item: CallingNumber, filterString) => {
        return regexSearch(item.name || '', filterString) || regexSearch(item.number || '', filterString);
      }
    };
  }

  get optionList(): Observable<CallingNumber[]> {
    return this.profileService.callingNumberList;
  }

  get wrappedControl(): FormControl {
    return this.flexSelect;
  }

  writeValue(val: CallingNumber): void {
    this.wrappedControl.setValue(val);
  }

  ngOnInit(): void {
    this.profileService.reloadCallingNumbers();
    super.ngOnInit();
    // this.hasInitilized = true;
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (this.queueId) {
  //     this.queue = this.callqueueRepo.getObjectById(this.queueId);
  //   } else {
  //     this.queue = undefined;
  //   }

  //   this.loadCallingNumbers().then(
  //     () => {
  //       // Set default value if any changes
  //       const firstOption = !_.isEmpty(this.optionList) ? this.optionList[0] : null;
  //       // tslint:disable-next-line: triple-equals
  //       const isEqual = firstOption && this.value ? firstOption.id == this.value.id : firstOption == this.value;
  //       if (!isEqual) {
  //         this.writeValue(firstOption);
  //         const event = new MatSelectChange(this.flexSelector.mySelect, this.value);
  //         this.onSelectionChange(event);
  //       }
  //     }, error => {
  //       this.writeValue(null);
  //       const event = new MatSelectChange(this.flexSelector.mySelect, this.value);
  //       this.onSelectionChange(event);
  //       this.toastService.showError(_ti('calling_number.error.load'));
  //       console.error('loadCallingNumbers error', error);
  //     }
  //   );
  // }

  onContainerClick(event: MouseEvent): void {
    this.profileService.reloadCallingNumbers();
  }

  get controlType(): string {
    return 'calling-number-select-form-input';
  }

  onSelectionChange($event: MatSelectChange): void {
    this.selectionChange.emit($event);
  }
}
